<div class="h-100 w-100 d-flex flex-column">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Close dialog" (click)="closeSuHelpersListDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div
        class="d-flex flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100" style="max-height: 90vh;">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 flex-shrink-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
            {{ "su-management.view-helpers-list" | translate }}
        </h4>
        <!-- loading -->
        <div *ngIf="isLoading" class="d-flex w-100 flex-grow-1 justify-content-center align-items-center">
            <mat-spinner class="zx-medium-icon-size"></mat-spinner>
        </div>
        <!-- helpers list container -->
        <div *ngIf="!isLoading" class="d-flex flex-column w-100 pb-2 overflow-y-auto" style="min-height: 0; max-height: calc(90vh - 120px);">
            <div *ngFor="let cluster of clusters" class="d-flex flex-column w-100 pb-4">
                <!-- cluster title -->
                <span class="d-flex pb-2 text-green">
                    <b>
                        {{ "su-management.branch" | translate }} {{ "choose-branch.naming." + cluster.serial_name | translate }}
                    </b>
                </span>
                <!-- helpers list -->
                <article class="d-flex flex-column w-100 pb-2" *ngIf="cluster.helpers && cluster.helpers.length > 0">
                    <div *ngFor="let helper of cluster.helpers" 
                        class="w-100 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center px-3 px-lg-5">
                        <div class="row zx-max-w-420 zx-w-lg-100 w-100">
                            <!-- displayName -->
                            <span
                                class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                                <span>
                                    {{ 'my-profile.username' | translate }}
                                </span>
                                <span class="d-none d-lg-inline">:</span>
                                <span class="zx-100-opp d-none d-lg-inline">_</span>
                                <span>
                                    {{ helper.userName }}
                                </span>
                            </span>
                            <!-- email -->
                            <span
                                class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                                <span>
                                    {{ 'my-profile.email' | translate }}
                                </span>
                                <span class="d-none d-lg-inline">:</span>
                                <span class="zx-100-opp d-none d-lg-inline">_</span>
                                <span>
                                    {{ helper.email }}
                                </span>
                            </span>
                            <!-- phone -->
                            <span
                                class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                                <span>
                                    {{ 'my-profile.phone' | translate }}
                                </span>
                                <span class="d-none d-lg-inline">:</span>
                                <span class="zx-100-opp d-none d-lg-inline">_</span>
                                <span *ngIf="helper.phone" class="d-flex flex-row-reverse">
                                    <span>0</span>
                                    <span>
                                        {{ ('0' + helper.phone.toString()).slice(1, 3) }}
                                    </span>
                                    <span>-</span>
                                    <span>
                                        {{ ('0' + helper.phone.toString()).slice(3, 7) }}
                                    </span>
                                    <span>-</span>
                                    <span>
                                        {{ ('0' + helper.phone.toString()).slice(7) }}
                                    </span>
                                </span>
                                <span *ngIf="!helper.phone">
                                    {{ 'su-management.not-existing' | translate }}
                                </span>
                            </span>
                        </div>
                    </div>
                </article>
                <!-- no helpers message -->
                <div *ngIf="!cluster.helpers || cluster.helpers.length === 0" 
                    class="w-100 d-flex justify-content-center py-3">
                    <span class="zx-text-small opacity-75">
                        {{ "su-management.no-helpers-in-cluster" | translate }}
                    </span>
                </div>
            </div>
            <!-- no clusters message -->
            <div *ngIf="clusters.length === 0" class="w-100 d-flex justify-content-center py-3">
                <span class="zx-text-small opacity-75">
                    {{ "su-management.no-helpers-found" | translate }}
                </span>
            </div>
        </div>
        <!-- // helpers list container -->

    </div>

</div>
